import { IInfrontStockItemSimple } from "@portal/types/infrontAllStocksSimple";

export type InfrontAllStocksSimpleSnapshot = {
  allStocks: IInfrontStockItemSimple[];
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
};

export type UpdateStockField = keyof IInfrontStockItemSimple;

const emptyStock = {
  index: -1,
  feed: -1,
  ticker: "",
  isin: "",
  name: "",
  flag: "",
} as IInfrontStockItemSimple;

const allStocks: IInfrontStockItemSimple[] = [];
const tempStocks: IInfrontStockItemSimple[] = [];
let status: InfrontAllStocksSimpleSnapshot["status"] = "idle";
let error: string | null = null;
const listeners = new Set<() => void>();
let snapshot: InfrontAllStocksSimpleSnapshot = { allStocks, status, error };

// Static server snapshot to satisfy useSyncExternalStore caching requirement
const serverSnapshot: InfrontAllStocksSimpleSnapshot = {
  allStocks: [],
  status: "idle",
  error: null,
};

const notifyListeners = () => listeners.forEach(listener => listener());

const updateSnapshot = () => {
  if (snapshot.allStocks !== allStocks || snapshot.status !== status || snapshot.error !== error) {
    snapshot = { allStocks, status, error };
  }
};

const setStateAndNotify = () => {
  updateSnapshot();
  notifyListeners();
};

const updateStock = (index: number, feed: number, value: string | number, field: UpdateStockField) => {
  const stock = allStocks.find(item => item.index === index && item.feed === feed);

  const tempStock = tempStocks.find(item => item.index === index && item.feed === feed);

  if (stock) {
    stock[field] = value as string;
  } else if (tempStock) {
    tempStock[field] = value as string;
    if (field === "name") {
      //move to allStocks
      allStocks.push(tempStock);
      tempStocks.splice(tempStocks.indexOf(tempStock), 1);
    }
  } else {
    tempStocks.push({
      ...emptyStock,
      index,
      feed,
      [field]: value,
    });
  }

  status = "succeeded";
  error = null;
  setStateAndNotify();
};

export const subscribeInfrontAllStocksSimpleStore = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const getInfrontAllStocksSimpleSnapshot = (): InfrontAllStocksSimpleSnapshot => {
  updateSnapshot();
  return snapshot;
};

export const getInfrontAllStocksSimpleServerSnapshot = (): InfrontAllStocksSimpleSnapshot => serverSnapshot;

export const setTickerSimpleStore = (index: number, feed: number, value: string | number) => {
  updateStock(index, feed, value, "ticker");
};

export const setIsinSimpleStore = (index: number, feed: number, value: string | number) => {
  updateStock(index, feed, value, "isin");
};

export const setNameSimpleStore = (index: number, feed: number, value: string | number) => {
  updateStock(index, feed, value, "name");
};

export const setFlagSimpleStore = (index: number, feed: number, value: string | number) => {
  updateStock(index, feed, value, "flag");
};
